import React from 'react';
import { Empty, Typography } from 'antd';
import { QRCodeSVG } from 'qrcode.react';
import { extractSubdomainSlug } from '../../utils/extractSubdomainSlug';

// Shows a large QR code to the tenant's public site so a guest can scan it,
// log in on their own phone and complete their profile.
const SignupQrPanel: React.FC = () => {
    // The admin app is served on the tenant subdomain, so the tenant's public
    // site root is just the current origin. A slug is still required so the QR
    // is hidden on the apex/reserved hosts (no tenant) rather than linking
    // somewhere useless.
    const tenantSlug = extractSubdomainSlug(window.location.hostname);
    const tenantUrl = tenantSlug ? window.location.origin : null;

    if (!tenantUrl) {
        return (
            <div data-testid="tour-signup-qr">
                <Empty description="Sign-up QR is only available on a club's own site." />
            </div>
        );
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 12,
                padding: 24,
                background: '#fafafa',
                border: '1px solid #f0f0f0',
                borderRadius: 8,
            }}
            data-testid="tour-signup-qr"
        >
            <Typography.Text strong>Scan QR Code to login and complete your profile</Typography.Text>
            <a
                href={tenantUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="tour-signup-qr-link"
            >
                <QRCodeSVG value={tenantUrl} size={220} level="M" marginSize={4} />
            </a>
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                {tenantUrl}
            </Typography.Text>
        </div>
    );
};

export default SignupQrPanel;
